import { render, staticRenderFns } from "./JgzLoading.vue?vue&type=template&id=7ef9d282&"
import script from "./JgzLoading.vue?vue&type=script&lang=js&"
export * from "./JgzLoading.vue?vue&type=script&lang=js&"
import style0 from "./JgzLoading.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports